import React, {useState} from "react"

export default function Default({json, dependencies, onFieldChange})
{       
    const [fieldValue, setfieldValue] = useState(json.value || '')    

    const fieldChanged = (e) => 
    {
        const value = e.target.value        
        setfieldValue(value)
        if(dependencies) dependencies(json.key, value)
        if(onFieldChange) onFieldChange(json.key, value)
    }

    const max = () => 
    {
        for (let i=0; i < json.validate.length; i++) 
        {            
            if(json.validate[i][0] === 'length' || json.validate[i][0] === 'maxlength')
            {
                const parts =  json.validate[i][1].split('|')

                if(parts.length !== 0) return parts[0].trim()
            }            
        }
        
        return false
    }

    const min = () =>
    {        
        for (let i=0; i < json.validate.length; i++) 
        {            
            if(json.validate[i][0] === 'minlength')
            {
                const parts =  json.validate[i][1].split('|')

                if(parts.length !== 0) return parts[0].trim()
            }            
        }
        
        return false
    }

    const getType = (validations) =>
    {
        let type = "text"

        for (let index = 0; index < json.validate.length; index++) 
        {
            switch(json.validate[index][0])
            {
                case 'numbers':
                    type = "number"
                    break
            }            
        }        
        
        return type
    }

    const fixMaxLength = (e) =>
    { 
        const value = e.target.value
        const maxLength = max()

        if(maxLength !== false)
        {
            if (value.length > maxLength) e.target.value = e.target.value.slice(0, maxLength)
        }        
    }

    const getField = () =>
    {
        switch(getType())
        {
            case 'number': return(<input className={'input_'+json.key} onInput={fixMaxLength} type='number' name={json.key} placeholder={json.placeholder || null} onChange={fieldChanged}  />)
            default: return(<input className={'input_'+json.key} type='text' maxLength={max()} minLength={min()} name={json.key} placeholder={json.placeholder || null} onChange={fieldChanged}  />)
        }
    }
    
    return (
        <>
            <div className={"json-input text default field_"+json.key}>
                {json.label && <label for={json.key} dangerouslySetInnerHTML={{__html: json.label}} />}
                {getField()} 
            </div>
        </>     
    ) 
}